<template>
  <div class="user_info">
    <el-dropdown trigger="click" @command="handleCommand">
      <span class="el-dropdown-link">
        <img v-if="headImage" :src="headImage" />
        <i v-else class="iconfont icon-yonghu"></i>
        <span>{{ userName }}</span>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown" style="width: 140px;">
        <el-dropdown-item command="password"><i class="el-icon-edit"></i> 修改密码</el-dropdown-item>
        <el-dropdown-item command="info"><i class="el-icon-user"></i> 修改个人资料</el-dropdown-item>
        <el-dropdown-item v-if="isValidated !== 'true'" command="verificat"><i class="iconfont icon-jurassic_verify"></i> 手机号码校验</el-dropdown-item>
        <el-dropdown-item command="logout"><i class="el-icon-switch-button"></i> 退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <el-dialog width="600px" :title="title" :visible.sync="dialogVisible" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" @closed="componet_select = ''">
      <component :is="componet_select" :ruleForm="ruleForm" :headImageUrl="head_image_url" @tableCloseDialog="dialogVisible = false" />
    </el-dialog>
  </div>
</template>

<script>
import Backend from '@/api/backend'
import loginHelper from '@/api/login_helper'
import userInfo from './info'
import passWord from './password'
import mobileCheck from './mobileCheck'

export default {
  name: 'user_info',
  data () {
    return {
      userName: localStorage.user_name,
      headImage: localStorage.head_image || '',
      dialogVisible: false,
      command: '',
      title: '',
      ruleForm: {},
      head_image_url: undefined,
      componet_select: '',
      isValidated: localStorage.getItem('is_validated')
    }
  },
  components: {
    'user-info': userInfo,
    'pass-word': passWord,
    'mobile-check': mobileCheck
  },
  created () {
    window.addEventListener('setItem', this.getIsValidated)
  },
  mounted () {
    this.getUserInfo()
  },
  beforeDestroy () {
    window.removeEventListener('setItem', this.getIsValidated)
  },
  methods: {
    getUserInfo () {
      Backend.post(this, '/user/get_info')
        .then(data => {
          for (const k in data) {
            this.$set(this.ruleForm, k, data[k])
          }
          this.$set(this.ruleForm, 'old_pwd', '')
          this.$set(this.ruleForm, 'new_pwd', '')
          this.$set(this.ruleForm, 'confirm_pwd', '')

          this.head_image_url = data.head_image_url
        })
    },
    getIsValidated () {
      this.isValidated = localStorage.getItem('is_validated')
    },
    handleCommand (command) {
      this.command = command
      switch (command) {
        case 'password':
          this.generalFunc('修改密码', 'pass-word')
          break
        case 'info':
          this.generalFunc('修改个人资料', 'user-info')
          this.getUserInfo()
          break
        case 'verificat':
          this.validateMobile()
          break
        case 'logout':
          this.handleExitClick()
          break
      }
    },
    generalFunc (title, componet) {
      this.title = title
      this.dialogVisible = true
      this.componet_select = componet
    },
    validateMobile () {
      const mobile = localStorage.mobile
      const Base64 = require('js-base64').Base64
      const decodeMobile = mobile ? Base64.decode(mobile) : ''
      const patt = /^1(3|4|5|7|8)\d{9}$/

      if (decodeMobile && patt.test(decodeMobile)) {
        this.generalFunc('验证手机号码', 'mobile-check')
      } else {
        this.$confirm('请先填写正确的手机号码, 再进行号码校验!', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false
        }).then(() => {
          this.handleCommand('info')
        }).catch(() => {
        })
      }
    },
    handleExitClick () {
      loginHelper.logout(this)
    },
    logout () {
      loginHelper.logout(this)
    }
  }
}
</script>

<style lang="scss">
  .user_info{
    .el-dropdown{
      display: unset;
      color: #ffffff;
    }
    .el-dropdown-link{
      display: flex;
      justify-content: center;
      align-items: center;
    }
    img{
      width: 32px;
      height: 32px;
      border-radius: 50%;
      margin-right: 10px;
    }
  }
  .exit {
    position: relative;
    padding: 5px 0 5px;
    height: 46px;
    font-size: small;
    vertical-align: middle;
    position: relative;
    transition: height 0.5s;
    div {
      width: 140px;
      position: absolute;
      transition: width 0.5s;
      color: white;
      cursor: pointer;
      white-space: nowrap;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      i,
      img {
        width: 32px;
        height: 32px;
        display: inline-block;
        border-radius: 16px;
      }
      span {
        overflow: hidden;
      }
    }
  }
</style>
